import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DesignService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get design info
  saveDesignInfo(formData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'site_configurations/updateDesign';
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = formData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
